import {Theme} from './theme';

/**
 * Theme to use before the actual theme is known and loaded.
 */
export const noTheme: Theme = {
	id: 'None',
	menuPage: '/general/warning',
	servingPage: '/general/warning',
	failedPage: '/general/warning',
	warningPage: '/general/warning'
};

/**
 * General iovent theme in blackboard style.
 */
export const blackboardTheme: Theme = {
	id: 'Blackboard',
	menuPage: '/blackboard/menu',
	payingPage: '/blackboard/paying',
	cupPage: '/blackboard/cup',
	servingPage: '/blackboard/serving',
	failedPage: '/blackboard/warning',
	warningPage: '/blackboard/warning'
};

/**
 * Theme for Dallmayr.
 */
export const dallmayrTheme: Theme = {
	id: 'Dallmayr',
	menuPage: '/dallmayr/menu',
	optionsPage: '/dallmayr/options',
	servingPage: '/dallmayr/serving',
	failedPage: '/dallmayr/warning',
	warningPage: '/dallmayr/warning'
};

/**
 * Theme for Dunkin Donuts.
 */
export const dunkinTheme: Theme = {
	id: 'Dunkin',
	menuPage: '/dunkin/menu',
	payingPage: '/dunkin/paying',
	cupPage: '/dunkin/cup',
	servingPage: '/dunkin/serving',
	failedPage: '/dunkin/warning',
	warningPage: '/dunkin/warning'
};

/**
 * Theme for Tank&Rast.
 */
export const turTheme: Theme = {
	id: 'TuR',
	menuPage: '/tur/menu',
	optionsPage: '/tur/options',
	payingPage: '/tur/menu',
	cupPage: '/tur/cup',
	servingPage: '/tur/serving',
	servedPage:'/tur/served',
	failedPage: '/tur/warning',
	warningPage: '/tur/warning',
	maintenancePage: '/tur/maintenance',
	updatePage: '/tur/update'
};

export const tur2Theme: Theme = {
	id: 'TuR2',
	menuPage: '/tur-2/menu',
	optionsPage: '/tur-2/options',
	payingPage: '/tur-2/paying',
	cupPage: '/tur-2/cup',
	servingPage: '/tur-2/serving',
	failedPage: '/tur-2/warning',
	warningPage: '/tur-2/warning'
};

export const ahaCoffeeTheme: Theme = {
	id: 'AhaCoffee',
	menuPage: '/aha/menu',
	optionsPage: '/aha/options',
	payingPage: '/aha/paying',
	cupPage: '/aha/cup',
	servingPage: '/aha/serving',
	failedPage: '/aha/warning',
	warningPage: '/aha/warning'
};

export const ahaSelfServiceTheme: Theme = {
	id: 'AhaSelfService',
	menuPage: '/aha/menu',
	optionsPage: '/aha/options',
	payingPage: '/aha/paying',
	cupPage: '/aha/cup',
	servingPage: '/aha/serving',
	failedPage: '/aha/warning',
	warningPage: '/aha/warning'
};

export const ahaShopTheme: Theme = {
	id: 'AhaShop',
	menuPage: '/aha/menu',
	optionsPage: '/aha/options',
	payingPage: '/aha/paying',
	cupPage: '/aha/cup',
	servingPage: '/aha/serving',
	failedPage: '/aha/warning',
	warningPage: '/aha/warning'
};

/**
 * Theme for Bäckerei Junge.
 */
export const jungeTheme: Theme = {
	id: 'Junge',
	menuPage: '/junge/menu',
	optionsPage: '/junge/options',
	payingPage: '/junge/paying',
	cupPage: '/junge/cup',
	servingPage: '/junge/serving',
	failedPage: '/junge/serving',
	warningPage: '/junge/warning'
};

export const allThemes: Theme[] = [noTheme, blackboardTheme, dallmayrTheme, dunkinTheme, turTheme, tur2Theme, jungeTheme, ahaCoffeeTheme, ahaSelfServiceTheme, ahaShopTheme];
